/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense, KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Paper, Select, MenuItem, Grid, Button, TextField, InputAdornment, Tooltip } from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../../../../../../../contexts";
import GENDERS from "../../../../../../../../../../constants/genders";
import { MARITAL_STATUSES } from "../../../../../../../../../../constants/maritalStatus";
import initCapitalize from "../../../../../../../../../../utils/commonFunctions/initCapitalize";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { DynamicForm } from "../../../../../../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import useRouteParam from "../../../../../../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../../../utils/api";
import ROLES from "../../../../../../../../../../constants/roles";
import { infoTitleMessage } from "../../../../../../../../../../constants/infoTitleMessage";
import { ConditionPosition } from "ag-grid-community/dist/lib/filter/provided/simpleFilter";
import { Validation } from "../../../../../../../../../../@types/validation.types";
import { LazySnackbarAPI } from "../../../../../../../../../shared";
import ExtractRouteParams from "../../../../../../../../../../utils/commonFunctions/extractRouteParams";
import { SnackbarProps } from "../../../../../../../../../../@types/snackbarAPI.types";
import SnackbarAPICall from "../../../../../../../../../shared/snackbar/SnackbarAPICall";

import SendIcon from "@material-ui/icons/Send";
import ReplyIcon from "@material-ui/icons/Reply";
import EventIcon from "@material-ui/icons/Event";
import InfoIcon from "@material-ui/icons/Info";

import "../../../../../../../../../../globalStyles/paperFormStyles.css";
import { Member } from "../../../../../../../../../../@types/member.types";
import { RELATIONSHIPS } from "../../../../../../../../../../constants/relationships";
import DEPENDENT_TYPES from "../../../../../../../../../../constants/dependentTypes";
import STATES from "../../../../../../../../../../constants/states";
import CONTACT_LABELS from "../../../../../../../../../../constants/contactLabels";
import validateEmail from "../../../../../../../../../../utils/commonFunctions/validateEmail";
import { handleSSNFormat } from "../../../../../../../../../../utils/commonFunctions/SSN";

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

const EditDependentContactInformation = (): JSX.Element => {
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const [editProfileForm, setEditProfileForm] = useState<DynamicForm>();
	const [employee, setEmployee] = useState<any>({
		member_id: "",
		employee_number: null,
		first_name: "",
		last_name: "",
		SSN: ""
	});
	const [dependent, setDependent] = useState<any>({
		dependent_number: null,
		first_name: "",
		last_name: "",
		email: "",
		SSN: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state: "",
		country: "USA - United States of America",
		ZIP: "",
		contact_label: "",
		phone_number: null,
		phone_extension: null,
		upload_type: "",
		dependent_status: ""
	});
	const { setDashboardHeader } = useContext(UIContext);
	const [dependentMongoID, setDependentMongoID] = useState<string>("");
	const [hasEditProfileSubmitClick, setHasEditProfileSubmitClick] = useState(false);
	const navigate = useNavigate();
	const [validation, setValidation] = useState<Validation>({
		dependent: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const [pasted, setPasted] = useState<boolean>(false);
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { user } = useContext(AuthContext);

	const handleValidation = useCallback(async () => {
		const { email, address_line_1, city, state, country, ZIP, contact_label, phone_number, phone_extension } =
			dependent;

		_validation.current = {
			...validation,
			dependent: {},
			status: "invalid"
		};
		let flag = true;

		// dependent validation checking
		if (email && email.trim().length > 0) {
			if (!validateEmail(email)) {
				_validation.current.dependent["email"] = "Valid Email is required";
				flag = false;
			}
		}
		// if (email.length === 0) {
		// 	_validation.current.dependent["email"] = "Email is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		// if (email.length !== 0) {
		// 	if (!validateEmail(email)) {
		// 		_validation.current.dependent["email"] = "Valid Email is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (contact_label.length === 0) {
			_validation.current.dependent["contact_label"] = "Contact Label is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (address_line_1.length === 0) {
			_validation.current.dependent["address_line_1"] = "Address Line 1 is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (city.length === 0) {
			_validation.current.dependent["city"] = "City is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (state.length === 0) {
			_validation.current.dependent["state"] = "State is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (country.length === 0) {
			_validation.current.dependent["country"] = "Country is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		// phone number (optional, validate only if provided)
		if (phone_number && String(phone_number).trim().length > 0) {
			if (String(phone_number).length !== 10) {
				_validation.current.dependent["phone_number"] = "Enter valid 10 digit phone number";
				flag = false;
			}
		}

		// phone extension (optional, max 3 digits)
		if (phone_extension && String(phone_extension).trim().length > 0) {
			if (String(phone_extension).length > 3) {
				_validation.current.dependent["phone_extension"] = "Enter Valid 3 digit Phone extension";
				flag = false;
			}
		}
		// if (phone_number === null) {
		// 	_validation.current.dependent["phone_number"] = "Phone number is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		// if (phone_number !== null) {
		// 	if (String(phone_number).length !== 10) {
		// 		_validation.current.dependent["phone_number"] = "Enter valid 10 digit phone number";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		// if (phone_extension !== null) {
		// 	if (String(phone_extension).length > 3) {
		// 		_validation.current.dependent["phone_extension"] = "Enter Valid 3 digit Phone extension";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (ZIP.length === 0) {
			_validation.current.dependent["ZIP"] = "ZIP Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length !== 0) {
			const _zip = ZIP.replaceAll("-", "");
			if (_zip.length !== 5 && _zip.length !== 9) {
				_validation.current.dependent["ZIP"] = "Enter 5 or 9 digit ZIP Code!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [dependent, validation]);

	const handleKeyCheck = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			let { value } = event.target as HTMLInputElement;
			const { name } = event.target as HTMLInputElement;
			const eventKey = event.key;

			if (name === "ZIP") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
				}
			}
		},
		[setDependent, dependent]
	);

	const handlePaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		// console.log("Paste");
		if (name === "ZIP") {
			setPasted(true);
			// setTimeout(() => null, 2000);
		}
	};

	const handleDependentContactInformationChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name } = event.target;
			let { value } = event.target;

			if (name === "phone_number") {
				if (!isNaN(value as any)) {
					if (value.length <= 10) {
						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						event.target.value = dependent.phone_number
							? (dependent.phone_number as unknown as string)
							: "";
						alert("Phone Number cannot be greater 10 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = dependent.phone_number ? (dependent.phone_number as unknown as string) : "";
				}
			} else if (name === "phone_extension") {
				if (!isNaN(value as any)) {
					if (value.length <= 3) {
						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						event.target.value = dependent.phone_extension
							? (dependent.phone_extension as unknown as string)
							: "";
						alert("Phone Extension cannot be greater 3 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = dependent.phone_extension
						? (dependent.phone_extension as unknown as string)
						: "";
				}
			} else if (name === "ZIP") {
				if (!pasted) {
					// console.log("Inside ZIP");
					const _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value) && value.length <= 10) {
						const zip = value;
						if (zip.length === 6) {
							value = value.substring(0, 5) + "-" + value.substring(5);
						}

						// console.log("ZIP Event", event.target.value);
						setDependent(
							Object.assign({}, dependent, {
								[name]: value
							})
						);
					} else {
						event.target.value = "";
						event.target.value = dependent.ZIP;
					}
				} else {
					setPasted(false);
					// console.log("Inside Paste");
					if (!isNaN(value as any)) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = dependent.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							// console.log("Inside Number");
							const zip = value;

							if (zip.length >= 6 && zip.length <= 9) {
								value = value.substring(0, 5) + "-" + value.substring(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						let zipValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", zipValue);
						alert("You have pasted alpha-numeric ZIP!");

						if (zipValue.length > 9) {
							event.target.value = "";
							event.target.value = dependent.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							const zip = zipValue;

							if (zip.length >= 6 && zip.length <= 9) {
								zipValue = zipValue.substring(0, 5) + "-" + zipValue.substring(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: zipValue }));
						}
					}
				}
			} else {
				setDependent(Object.assign({}, dependent, { [name]: value }));
			}
		},
		[dependent, pasted]
	);

	const handleHyphenInZip = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "-") {
			event.preventDefault();
		}
	};

	const getDependentBySSNWithEmployee = useCallback(async (SSN: string, group_number: number) => {
		const findDependentWithEmployeeQuery = {
			group_number,
			SSN
		};

		const members = await trackPromise(api.member.getDependentBySSNWithEmployee(findDependentWithEmployeeQuery));
		if (members) {
			const { employeeInstance, dependentInstance } = members;
			if (employeeInstance) {
				const { member_id, first_name, last_name, employee_number, SSN } = employeeInstance;
				const _employeeInstance = {
					member_id,
					employee_number,
					first_name,
					last_name,
					SSN
				};
				setEmployee(Object.assign({}, _employeeInstance));
			}
			if (dependentInstance) {
				const {
					_id,
					dependent_number,
					first_name,
					last_name,
					email,
					SSN,
					address_line_1,
					address_line_2,
					city,
					state,
					country,
					ZIP,
					contact_label,
					phone_number,
					phone_extension,
					upload_type,
					dependent_status
				} = dependentInstance;

				setDependentMongoID(_id as string);

				// Converting ZIP into required format
				let _ZIP = String(ZIP);
				if (_ZIP.length > 5) _ZIP = ZIP?.substring(0, 5) + "-" + ZIP?.substring(5);

				const _dependentInstance = {
					dependent_number,
					first_name,
					last_name,
					email,
					SSN,
					address_line_1,
					address_line_2,
					city,
					state,
					country,
					ZIP: _ZIP,
					contact_label,
					phone_number,
					phone_extension,
					upload_type,
					dependent_status
				};
				setDependent(Object.assign({}, _dependentInstance));
			}
		}
	}, []);

	const handleRedirectToDependentDetails = useCallback(() => {
		const pathname = `/employer/member/dependent?${routeParam}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleEditDependentContactSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { ZIP } = dependent;

					const payload: Member = {
						...dependent,
						ZIP: ZIP !== "" || ZIP !== null || ZIP !== undefined ? ZIP?.replaceAll("-", "") : ""
					};

					// console.log("Payload", payload);
					const response: Member = await trackPromise(
						api.member.editDependentContactInformationById(payload, dependentMongoID as string)
					);

					if (response) {
						setHasEditProfileSubmitClick(true);
						// console.log("Response", response);

						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "Dependent Contact Edited Successfully!",
								severity: "success"
							})
						);

						// alert("Edit Dependent Profile Submission Successfully!");

						setTimeout(() => {
							handleRedirectToDependentDetails();
						}, 2000);
					}
				} else {
					setHasEditProfileSubmitClick(false);
				}
			} catch (error) {
				setHasEditProfileSubmitClick(false);
				alert("Dependent Contact Edit Unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[dependent, handleValidation, snackbarAPICallProps]
	);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.edit_dependent_contact);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) getDependentBySSNWithEmployee(querySSN as string, queryGroupNumber as number);
	}, [getDependentBySSNWithEmployee, querySSN, queryGroupNumber]);

	useEffect(() => {
		setEditProfileForm(
			Object.assign(
				{},
				{
					"Employee Information": [
						{
							schema: "employee",
							label: "Employee Id",
							name: "member_id",
							onChange: () => null,
							value: employee.member_id,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "WLT Employee Number",
							name: "employee_number",
							onChange: () => null,
							value: employee.employee_number,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "First Name",
							name: "first_name",
							value: employee.first_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "Last Name",
							name: "last_name",
							value: employee.last_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "SSN / ALt Id",
							name: "SSN",
							onChange: () => null,
							value: handleSSNFormat(user, employee.SSN),
							type: "textfield"
						}
					],
					"Dependent Contact Information": [
						{
							schema: "dependent",
							label: "WLT Dependent number",
							name: "dependent_number",
							onChange: () => null,
							value: dependent.dependent_number,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "First Name",
							name: "first_name",
							value: dependent.first_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Last Name",
							name: "last_name",
							value: dependent.last_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "SSN",
							name: "SSN",
							onChange: () => null,
							value: handleSSNFormat(user, dependent.SSN),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Email",
							name: "email",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							value: dependent.email,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Contact Label",
							name: "contact_label",
							value: dependent.contact_label,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "select",
							options: CONTACT_LABELS
						},
						{
							schema: "dependent",
							label: "Phone Number",
							name: "phone_number",
							value: dependent.phone_number,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Phone Extension",
							name: "phone_extension",
							value: dependent.phone_extension,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Address Line 1",
							name: "address_line_1",
							value: dependent.address_line_1,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Address Line 2",
							name: "address_line_2",
							value: dependent.address_line_2,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "City",
							name: "city",
							value: dependent.city,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "State",
							name: "state",
							value: dependent.state,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "select",
							options: STATES
						},
						{
							schema: "dependent",
							label: "Country",
							name: "country",
							value: dependent.country,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "ZIP Code",
							name: "ZIP",
							value: dependent.ZIP,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentContactInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Upload Type",
							name: "upload_type",
							onChange: () => null,
							value: dependent.upload_type,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Dependent Status",
							name: "dependent_status",
							onChange: () => null,
							value: dependent.dependent_status,
							type: "textfield"
						}
					]
				}
			)
		);
	}, [employee, dependent, handleDependentContactInformationChange]);

	// console.log("Employee", employee);
	// console.log("Dependent", dependent);

	// console.log("DependentMongoID", dependentMongoID);

	return (
		<div className="edit-profile-information-container">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditDependentContactSubmitClick}
					variant="contained"
					disabled={hasEditProfileSubmitClick}
					style={{
						cursor: hasEditProfileSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{editProfileForm &&
					Object.entries(editProfileForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Paper className="pf-paper-container" variant="outlined" elevation={3}>
									{value.map((field, index) => {
										const { schema, name, label, value, type, onChange } = field;
										return (
											<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
												<Grid container spacing={1} className="pf-label">
													<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
														<div className="pf-label-text" id="pf-label-text">
															{label}
														</div>
													</Grid>
													<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
														{type === "textfield" ? (
															<TextField
																className="input-text-field"
																id={
																	schema === "employee"
																		? "disabled-input-text-field"
																		: schema === "dependent"
																		? name === "dependent_number" ||
																		  name === "first_name" ||
																		  name === "last_name" ||
																		  //   name === "email" ||
																		  name === "SSN" ||
																		  name === "country" ||
																		  name === "upload_type" ||
																		  name === "dependent_status"
																			? "disabled-input-text-field"
																			: "input-text-field"
																		: "input-text-field"
																}
																value={
																	name === "upload_type"
																		? value
																			? initCapitalize(value as string)
																			: value
																		: name === "dependent_status"
																		? value
																			? initCapitalize(value as string)
																			: value
																		: value
																}
																name={name}
																onChange={onChange}
																onKeyDown={(
																	event: React.KeyboardEvent<HTMLDivElement>
																) => handleKeyCheck(event)}
																onPaste={(
																	event: React.ClipboardEvent<HTMLDivElement>
																) => handlePaste(event)}
																variant="outlined"
																disabled={
																	schema === "employee"
																		? true
																		: schema === "dependent"
																		? name === "dependent_number" ||
																		  name === "first_name" ||
																		  name === "last_name" ||
																		  //   name === "email" ||
																		  name === "SSN" ||
																		  name === "country" ||
																		  name === "upload_type" ||
																		  name === "dependent_status"
																			? true
																			: false
																		: false
																}
																inputProps={{
																	onKeyDown:
																		name === "ZIP" ? handleHyphenInZip : undefined
																}}
																InputProps={{
																	endAdornment: (
																		<>
																			{schema === "employee" ? (
																				<InputAdornment position="end">
																					<LightTooltip
																						title={
																							name === "employee_number"
																								? infoTitleMessage.employee_number
																								: name === "member_id"
																								? infoTitleMessage.member_id
																								: name === "SSN"
																								? infoTitleMessage.SSN
																								: name === "first_name"
																								? infoTitleMessage.first_name
																								: name === "last_name"
																								? infoTitleMessage.last_name
																								: ""
																						}
																						placement="right-start"
																						arrow
																					>
																						<InfoIcon
																							style={{
																								color: "#808080",
																								fontSize: "20px",
																								// cursor: !showSaveButton
																								// 	? "default"
																								// 	: "pointer",
																								pointerEvents: "unset"
																							}}
																						/>
																					</LightTooltip>
																				</InputAdornment>
																			) : schema === "dependent" ? (
																				name === "dependent_number" ||
																				name === "first_name" ||
																				name === "last_name" ||
																				// name === "email" ||
																				name === "SSN" ||
																				name === "country" ||
																				name === "upload_type" ||
																				name === "dependent_status" ? (
																					<InputAdornment position="end">
																						<LightTooltip
																							title={
																								name ===
																								"dependent_number"
																									? infoTitleMessage.dependent_number
																									: // : name === "email"
																									// ? infoTitleMessage.email
																									name === "SSN"
																									? infoTitleMessage.SSN
																									: name ===
																									  "upload_type"
																									? infoTitleMessage.upload_type
																									: name ===
																									  "dependent_status"
																									? infoTitleMessage.dependent_status
																									: name ===
																									  "first_name"
																									? infoTitleMessage.first_name
																									: name ===
																									  "last_name"
																									? infoTitleMessage.last_name
																									: name === "country"
																									? infoTitleMessage.country
																									: ""
																							}
																							placement="right-start"
																							arrow
																						>
																							<InfoIcon
																								style={{
																									color: "#808080",
																									fontSize: "20px",
																									// cursor: !showSaveButton
																									// 	? "default"
																									// 	: "pointer",
																									pointerEvents:
																										"unset"
																								}}
																							/>
																						</LightTooltip>
																					</InputAdornment>
																				) : null
																			) : null}
																		</>
																	),
																	readOnly:
																		schema === "employee"
																			? true
																			: schema === "dependent"
																			? name === "dependent_number" ||
																			  name === "first_name" ||
																			  name === "last_name" ||
																			  //   name === "email" ||
																			  name === "SSN" ||
																			  name === "country" ||
																			  name === "upload_type" ||
																			  name === "dependent_status"
																				? true
																				: false
																			: false
																}}
																helperText={validation.dependent[name]}
																style={{
																	pointerEvents: "unset",
																	width: "340px",
																	borderRadius: 50
																}}
															/>
														) : type === "select" ? (
															<>
																<Select
																	id="text-align-options"
																	name={name}
																	value={value}
																	onChange={onChange}
																	style={{
																		pointerEvents: "unset",
																		minWidth: 180,
																		textAlign: "left",
																		overflowY: "visible"
																	}}
																	MenuProps={{
																		style: { zIndex: 35960 }
																	}}
																	inputProps={{ "aria-label": "Without label" }}
																>
																	<MenuItem value="" disabled>
																		Select Value
																	</MenuItem>
																	{field?.options?.map((option) => {
																		return (
																			<MenuItem key={option} value={option}>
																				{name !== "state"
																					? option
																						? initCapitalize(
																								option as string
																						  )
																						: option
																					: option}
																			</MenuItem>
																		);
																	})}
																</Select>
																{validation && validation.dependent[name] ? (
																	<div className="details">
																		<span className="select-validation-text2">
																			{field.schema === "dependent"
																				? validation.dependent[name]
																				: ""}
																		</span>
																	</div>
																) : null}
															</>
														) : type === "date" ? (
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	className="from-date-input"
																	id="from-date-input"
																	inputVariant="outlined"
																	label={label}
																	name={name}
																	format="MM/dd/yyyy"
																	error={false}
																	value={value}
																	onChange={(date: MaterialUiPickersDate) =>
																		onChange(date, name)
																	}
																	InputProps={{
																		readOnly: true
																	}}
																	InputLabelProps={{
																		shrink: true
																	}}
																	keyboardIcon={
																		<EventIcon
																			style={{
																				color: "#7cb342"
																			}}
																		/>
																	}
																	KeyboardButtonProps={{
																		"aria-label": "change date"
																	}}
																	style={{
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																	helperText={validation.dependent[name]}
																/>
															</MuiPickersUtilsProvider>
														) : null}
													</Grid>
												</Grid>
											</Grid>
										);
									})}
								</Paper>
							</div>
						);
					})}
			</Grid>
			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditDependentContactSubmitClick}
					variant="contained"
					disabled={hasEditProfileSubmitClick}
					style={{
						cursor: hasEditProfileSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default EditDependentContactInformation;
